const Nav = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.button = document.getElementById('menu-button');
    DOM.nav = document.getElementById('main-nav')
  };

  const eventlistener = () => {
    DOM.button.addEventListener('click', function() {
      if(DOM.nav.classList.contains('nav-show')) {
        DOM.nav.classList.remove('nav-show');
        DOM.nav.setAttribute('style', `height: 0`);
      } else {
        DOM.nav.classList.add('nav-show');
        DOM.nav.setAttribute('style', `height: ${DOM.nav.scrollHeight}px`);
      }
    })
  };

  const init = () => {
    cacheDOM();
    eventlistener();

  };

  return {
    init

  }
})();

export default Nav;


